import React from "react";

function FlashMessages(props) {
  return (
    <div className="floating-alerts">
      {props.messages.map((msg, index) => {
        let classes = ["notification", "floating-alert"];
        if (msg.type) classes.push(msg.type);
        return (
          <div key={index} className={classes.join(' ')}>
            {msg.text}
          </div>
        );
      })}
    </div>
  );
}
export default FlashMessages;
